import { useEffect, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { getCampaigns } from '../../services/campaign';

type Campaign = {
  userAccess: boolean;
  refillAccess: boolean;
};

type EcommSales = {
  shop: Campaign;
  edit: Campaign;
  season: Campaign;
};

export const useCampaigns = () => {
  const [ecommSales, setEcommSales] = useState<EcommSales | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchCampaings() {
      try {
        const campaingsData = await getCampaigns();
        setEcommSales(campaingsData);
      } catch (e: unknown) {
        datadogLogs.logger.error(e.message || e);
        console.error(e);
        setError(e);
      } finally {
        setIsLoading(false);
      }
    }
    fetchCampaings();
  }, []);

  const editUserAccess = !!ecommSales?.edit.userAccess;
  const editRefillAccess = !!ecommSales?.edit.refillAccess;

  return { ecommSales, isLoading, error, editUserAccess, editRefillAccess };
};
